<template>
  <div class="flex justify-center items-center">
    <div style="border-top-width: 2px; border-bottom-width: 2px;" class="animate-spin rounded-full" :class="['h-4 w-4 border-primary']"></div>
  </div>
</template>

<script setup>
import { onBeforeUnmount } from "vue"

const emit = defineEmits(["unmounted"])

// const props = defineProps({
//   size: {
//     type: String,
//     default: "md"
//   },
//   color: {
//     type: String,
//     default: "primary"
//   }
// })

// const propClasses = computed(() => {
//   return `size-${props.size} ${props.color ? `color-${props.color}` : ""}`
// })

onBeforeUnmount(() => emit("unmounted"))
</script>

<style scoped>
.animate-spin {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
